import React from "react";
import Marquee from "react-fast-marquee";
import { useWindowSize } from "@/hooks/useIsMobile";
// import electionKeys from "@/constants/electionKeys";
import { useEffect } from "react";

const AvailableScripts = [
  {
    script: `var imp_track_ITGD = new Image();imp_track_ITGD.src = 'https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501708&loop=1&';`,
    noscript: `<img width="1" height="1" border="0" src="https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501708&z=[timestamp]"/>`,
  },
  {
    script: `var imp_track_ITGD = new Image();imp_track_ITGD.src = 'https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501681&loop=1&';`,
    noscript: `<img width="1" height="1" border="0" src="https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501681&z=[timestamp]"/>`,
  },
  {
    script: `var imp_track_ITGD = new Image();imp_track_ITGD.src = 'https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501691&loop=1&';`,
    noscript: `<img width="1" height="1" border="0" src="https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501691&z=[timestamp]"/>`,
  },
  {
    script: `var imp_track_ITGD = new Image();imp_track_ITGD.src = 'https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501697&loop=1&';`,
    noscript: `<img width="1" height="1" border="0" src="https://imptrack.intoday.in/impression_tracker.php?domain=NEWSTAK&clientCode=501697&z=[timestamp]"/>`,
  },
  // {
  //   script: `var imp_track_ITGD = new Image();imp_track_ITGD.src = 'https://imptrack.intoday.in/impression_tracker.php?domain=UPTAK&clientCode=501695&loop=1&';`,
  //   noscript: `<img width="1" height="1" border="0" src="https://imptrack.intoday.in/impression_tracker.php?domain=UPTAK&clientCode=501695&z=[timestamp]"/>`,
  // },
  // Add more scripts as needed
];

const Sponsor = ({color,name,electionKeys}) => {
  const size = useWindowSize();
  useEffect(() => {
    // Create the script element
    let tempScripts = AvailableScripts;
    let elements = [];

    for(let adScript of tempScripts){
      let script = document.createElement('script');
      script.innerHTML = adScript.script;
      document.body.appendChild(script);
      elements.push(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = adScript.noscript;
      document.body.appendChild(noscript);
      elements.push(noscript);
    }
    return () => {
      elements.forEach((element) => document.body.removeChild(element));
    };
  }, [AvailableScripts]);
  const showSponsor = electionKeys?.showSponsor;
 
  const ar = [
    {
      url: `https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501709&k=https%3A%2F%2Ftinyurl.com%2Fhkucwfzb`,
      image: "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/tecno.png",
    },
    {
      url: `https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501682&k=https%3A%2F%2Fbit.ly%2F3KoYy6U`,
      image:
        "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/agiluslogo.jpg",
    },
    {
      url: `https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501698&k=https%3A%2F%2Fwww.godrej.com%2Fappliances%2Feonvogue%3Futm_source%3DSportsTak%26amp%3Butm_medium%3DCPM%26amp%3Butm_campaign%3D434E_GNB_App_SportsTak_Election_June24`,
      image:
        "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/90x55_1.png",
    },
    {
        url: `https://imptrack.intoday.in/click_tracker.php?domain=NEWSTAK&clientCode=501692&k=https%3A%2F%2Fdavaindia.com%2F`,
        image:
          "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/87x55.png",
    },
    // {
    //     url: `https://imptrack.intoday.in/click_tracker.php?domain=UPTAK&clientCode=501694&k=https%3A%2F%2Fwww.unienzyme.com%2F%3Futm_source%3DZenith%26amp%3Butm_medium%3DUPTak_YouTube%26amp%3Butm_campaign%3DTorrentpharma_Unienzyme_Campaign_UP_May_2024_UPTak_YT_LiveSpotVideo%26amp%3Butm_term%3DLiveSpotVideo_UPTak_UP_May2024%26amp%3Butm_content%3DLiveSpotVideo_UPTak_UP_May2024`,
    //     image:
    //       "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/unienzyme.png",
    // },
  ];
  return (
    <> 
      {showSponsor ? (
        <>
          {size.width < 768 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: color,
                paddingBottom: "1rem",
                marginTop: "1rem",
                position: "sticky",
              }}
            >
              <img
                src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/image_effect.png"
                width="100%"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  zIndex: "-1",
                }}
              ></img>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "1rem",
                  gap: "8px",
                  cursor: "pointer",
                }}
                onClick={() => window.open("/election/lok-sabha-elections-2024", "_self")}
              >
                <div
                  style={{
                    fontSize: "35px",
                    fontWeight: "700",
                    color: "white",
                  }}
                >
                  {name}
                </div>
                {name!=""&&<img
                  src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/2024.png"
                  width="83px"
                  height="34px"
                  style={{ alignSelf: "center" }}
                ></img>}
              </div>
              <div>
                {name!=""&<div
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "14px",
                    // color: "white",
                    paddingLeft: "20px",
                    paddingTop: "10px",
                  }}
                >
                  In Association With
                </div>}
                <div style={{ paddingTop: "5px", paddingLeft: "20px"}}>
                  {/* <marquee width="100%" direction="left" height="100px" loop="infinite"> */}
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={30}
                    autoFill={true}
                    loop={0}
                  >
                    <div style={{ display: "flex", gap: "0.7rem"  , marginLeft:'10px' }}>
                      {ar.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              width: "75px",
                              height: "44px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open(item?.url, "_blank");
                            }}
                          >
                            <img src={item?.image} alt={'sponsor'} style={{minHeight:"44px" , minWidth:"75px" , maxHeight:"44px" , maxWidth:"75px"}}></img>
                          </div>
                        );
                      })}
                    </div>
                  </Marquee>
                  {/* </marquee> */}
                </div>
              </div>
            </div>
          )}
          {size.width > 768 && (
            <div
              style={{
                width: "100%",
                height: "90px",
                backgroundColor: color,
                display: "flex",
                marginTop: "1rem",
                gap: "15px",
                position: "relative",
              }}
            >
              <img
                src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/image_effect_desktop.png"
                width="100%"
                style={{ position: "absolute", height: "100%", width: "100%" }}
              ></img>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  minWidth: "fit-content",
                  height: "100%",
                  paddingLeft: "15px",
                  cursor: "pointer",
                  position: "absolute",
                }}
                onClick={() =>
                  window.open("/election/lok-sabha-elections-2024", "_self")
                }
              >
                <div
                  style={{
                    fontSize: "35px",
                    fontWeight: "700",
                    color: "white",
                    alignSelf: "center",
                  }}
                >
                  {name}
                </div>
                {name!="" && <img
                  src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/2024.png"
                  width="83px"
                  height="30px"
                  style={{ alignSelf: "center" }}
                ></img>}
              </div>
              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  left: "25%",
                  zIndex: "0",
                }}
              >
                {name!=""&&<div
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "14px",
                    // color: "white",
                    paddingTop: "10px",
                  }}
                >
                  In Association With
                </div>}
                <div style={{ paddingTop: "5px", width: "75%" }}>
                  {/* <marquee width="100%" direction="left" height="100px" loop="infinite"> */}
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={30}
                    // autoFill={true}
                    loop={0}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "1.7rem",
                        cursor: "pointer",
                        marginLeft:'25px' 
                      }}
                    >
                      {ar.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              width: "87px",
                              minHeight: "55px",
                              maxHeight: "55px",
                            }}
                            onClick={() => {
                              window.open(item?.url, "_blank");
                            }}
                          >
                            <img src={item?.image} alt="sponsor" style={{minHeight:"55px" , minWidth:"87px" , maxHeight:"55px" , maxWidth:"87px"}}></img>
                          </div>
                        );
                      })}
                    </div>
                  </Marquee>
                  {/* </marquee> */}
                </div>
              </div>
            </div>
          )}          
          <style>
            {`
          .rfm-marquee-container{
            overflow:hidden !important;
          }
          `}
          </style>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Sponsor;
